import Icon from "~/components/shared/Icon";
import EmojiAvatar from "~/components/shared/EmojiAvatar";
import { Example } from "~/components/shared/Examples/useExamples";

export function ExamplesList({
  examples,
  onSelect,
}: {
  examples: Example[];
  onSelect: (example: Example) => void;
}) {
  return (
    <ul className="space-y-0.5 px-1 py-2">
      {examples.map((example) => (
        <li key={example.slug}>
          <button
            className="flex w-full items-center gap-2 rounded-md px-2 py-1 hover:bg-gray-100"
            onClick={() => onSelect(example)}
          >
            <EmojiAvatar
              emoji={example.emoji}
              color={example.color}
              fallbackColor="var(--gray-100)"
              size={32}
            />

            <div className="truncate font-medium" title={example.name}>
              {example.name}
            </div>

            <Icon
              icon="heroicons/20/solid/chevron-right"
              className="text-charcoal-300 ml-auto size-5 shrink-0"
            />
          </button>
        </li>
      ))}
    </ul>
  );
}
